module.exports = __webpack_public_path__ + "img/icon-wizard-assegna-attuatore.ff6687dc.svg";